import React, { useState } from 'react';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import PropTypes from 'prop-types';

import DepartmentDropdownItem from './DepartmentDropdownItem';

import {
    DEFAULT_DEPARTMENT,
    DEPARTMENT_DROPDOWN_ID,
    ALL_DEPARTMENTS_TEXT,
} from '../config/constants';

export const DepartmentDropdown = ({ departments = [], onDepartmentChange }) => {
    const allDepartmentsItem = { id: DEFAULT_DEPARTMENT, name: ALL_DEPARTMENTS_TEXT };
    const [selectedDepartment, setSelectedDepartment] = useState(allDepartmentsItem);

    const handleDepartmentClick = (department) => () => {
        setSelectedDepartment(department);
        onDepartmentChange?.(department.id);
    };

    return (
        <div className="department-dropdown-container">
            <DropdownButton
                id={DEPARTMENT_DROPDOWN_ID}
                title={<DepartmentDropdownItem text={selectedDepartment.name} />}
            >
                {departments.map((department) => (
                    <MenuItem
                        key={department.id}
                        onClick={handleDepartmentClick(department)}
                    >
                        <DepartmentDropdownItem text={department.name} />
                    </MenuItem>
                ))}
            </DropdownButton>
        </div>
    );
};

DepartmentDropdown.propTypes = {
    departments: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            name: PropTypes.string.isRequired,
        }),
    ),
    onDepartmentChange: PropTypes.func,
};

export default DepartmentDropdown;
